import * as types from '../actions/actionTypes';
import initialState from './initialState';

/**
 *
 * @param {Array} state
 * @param {Object} action
 * @returns {*}
 */
export default function articlesCategoryListReducer(state = initialState.articleCategories, action) {
    switch (action.type) {
        case types.LOAD_ARTICLE_CATEGORIES_SUCCESS:
            return action.articleCategories;
        case types.CREATE_ARTICLE_CATEGORY_SUCCESS:
            return [...state, ...action.category];
        case types.UPDATE_ARTICLE_CATEGORY_SUCCESS:
            return replaceItemInList(state, action.category);
        case types.DELETE_ARTICLE_CATEGORY_SUCCESS:
            return state.filter(category => category.id !== action.category.id);
        case types.REACTIVATE_ARTICLE_CATEGORY_SUCCESS:
            return replaceItemInList(state, action.category);
        default:
            return state;
    }
}

/**
 *
 * @param {Array} categories
 * @param {Object} activatedCategory
 * @returns {*}
 */
function replaceItemInList(categories, activatedCategory) {
    let index = categories.findIndex(category => category.id === activatedCategory.id);
    let categoriesCopy = categories.filter(category => category.id !== activatedCategory.id);
    categoriesCopy.splice(index, 0, activatedCategory);

    return categoriesCopy;
}


// WEBPACK FOOTER //
// ./web/src/reducers/articleCategoryListReducer.js